import {PersonnelVI} from "./personnel/vi";
import {ApplicationVI} from "./application/vi";
import {TimeKeepingVI} from "./timekeeping/vi";
import {CmsVI} from "./cms/vi";
import {ProcessSettingVI} from "./process/en";

export const SettingVI = {
    "generalSettings": "Cài đặt chung",
    "setting":"Cài đặt",
    ...PersonnelVI,
    ...ApplicationVI,
    ...TimeKeepingVI,
    ...CmsVI,
    ...ProcessSettingVI,

}